<template>
    <div id="hoursOfOperationCheckinForm">
        <div v-for="(key, i) in weekdays" :key="i" class="card">
            <div class="accordion" id="hoursOfOperationAccordion">
                <div class="card-header" :id="key + 'Heading'">
                    <button class="btn btn-kings btn-link btn-block font-weight-bold text-left" type="button"
                        data-toggle="collapse" :data-target="getDataTarget(key)" aria-expanded="true"
                        :aria-controls="getId(key)">
                        {{ days[key].label }} <small v-if="validateCheckinHours(days[key].checkinHours)"
                            class="text-danger">(Required form field(s) are missing information)</small>
                    </button>
                </div>
                <div :id="getId(key)" class="collapse" :aria-labelledby="key + 'Heading'"
                    data-parent="#hoursOfOperationAccordion">
                    <div class="card-body">
                        <form>
                            <div class="text-right">
                                <button type="button" class="btn btn-primary"
                                    @click="addHoursOfOperation(days[key].checkinHours)"><i class="fas fa-plus"></i>
                                    Add</button>
                            </div>
                            <div v-for="(time, i) in days[key].checkinHours" :key="i" class="form-group">
                                <label class="pr-2">Hours {{ i + 1}}:</label>
                                <vue-timepicker v-model="time.startTime" format="hh:mm A" :minute-interval="15"
                                    placeholder="Start Time">
                                </vue-timepicker>
                                <span> to </span>
                                <vue-timepicker v-model="time.endTime" format="hh:mm A" :minute-interval="15"
                                    placeholder="End Time">
                                </vue-timepicker>
                                <button type="button" class="btn btn-danger btn-sm ml-2"
                                    @click="removeHoursOfOperation(days[key].checkinHours, i)"><i
                                        class="fas fa-trash"></i></button>
                                <div v-if="validateHoursOfOperation(time.startTime, time.endTime)"
                                    class="invalid-feedback">
                                    Please provide a start time and end time.
                                </div>
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>Show Message</label>
                                <select v-model="days[key].showMessage" class="form-control">
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Message (Optional)</label>
                                <textarea v-model="days[key].message" class="form-control"
                                    placeholder="Please provide a message.."></textarea>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    name: 'hours-of-operation-checkin-settings-form',
    components: {
        VueTimepicker
    },
    props: {
        settings: {
            required: true
        }
    },
    data() {
        return {
            days: {
                monday: {
                    checkinHours: [],
                    label: 'Monday',
                    message: '',
                    showMessage: 0
                },
                tuesday: {
                    checkinHours: [],
                    label: 'Tuesday',
                    message: '',
                    showMessage: 0
                },
                wednesday: {
                    checkinHours: [],
                    label: 'Wednesday',
                    message: '',
                    showMessage: 0
                },
                thursday: {
                    checkinHours: [],
                    label: 'Thursday',
                    message: '',
                    showMessage: 0
                },
                friday: {
                    checkinHours: [],
                    label: 'Friday',
                    message: '',
                    showMessage: 0
                },
                saturday: {
                    checkinHours: [],
                    label: 'Saturday',
                    message: '',
                    showMessage: 0
                },
                sunday: {
                    checkinHours: [],
                    label: 'Sunday',
                    message: '',
                    showMessage: 0
                }
            },
            weekdays: [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday'
            ]
        }
    },
    methods: {
        addHoursOfOperation(checkinHours) {
            if (checkinHours) {
                checkinHours.push({
                    endTime: {
                        hh: '',
                        mm: '',
                        A: ''
                    },
                    startTime: {
                        hh: '',
                        mm: '',
                        A: ''
                    }
                });
            }
        },
        getDataTarget(key) {
            return `#collpase-${key}`;
        },
        getId(key) {
            return `collpase-${key}`;
        },
        getSettings() {
            return {
                days: this.days,
                type: 'checkin-hours'
            }
        },
        removeHoursOfOperation(checkinHours, index) {
            if (checkinHours) {
                checkinHours.splice(index, 1);
            }
        },
        setSettings() {
            let settings = this.settings.types || [];
            let system = {};

            if (settings.length > 0) {
                settings.forEach(setting => {
                    system = setting.type && setting.type == "checkin-hours" ? setting : system;
                });
            }

            this.days = system.days ? system.days : this.days;
        },
        validateCheckinHours(checkinHours) {
            let bool = false;

            for (let i = 0; i < checkinHours.length; i++) {
                let startTime = checkinHours[i].startTime;
                let startHour = startTime.hh;
                let startMin = startTime.mm;
                let endTime = checkinHours[i].endTime;
                let endHour = endTime.hh;
                let endMin = endTime.mm;

                // Convert hours
                startHour = startHour == "12" ? "00" : startHour;
                endHour = endHour == "12" ? "00" : endHour;

                // Convert PM
                if (startTime.A == "PM") {
                    startHour = parseInt(startHour, 10) + 12;
                }

                if (endTime.A == "PM") {
                    endHour = parseInt(endHour, 10) + 12;
                }

                if (!(parseInt(String(`${startHour}${startMin}`)) <= parseInt(String(`${endHour}${endMin}`)))) {
                    bool = true;
                    break;
                }
            }

            return bool;
        },
        validateForm() {
            let bool = false;

            for (const [key, day] of Object.entries(this.days)) {
                let checkinHours = day.checkinHours || [];
                bool = this.validateCheckinHours(checkinHours);

                if (bool) {
                    break;
                }
            }

            return bool;
        },
        validateHoursOfOperation(startTime, endTime) {
            if (startTime && startTime.hh && startTime.mm && endTime && endTime.hh && endTime.mm) {
                let startHour = startTime.hh;
                let startMin = startTime.mm;
                let endHour = endTime.hh;
                let endMin = endTime.mm;

                // Convert hours
                startHour = startHour == "12" ? "00" : startHour;
                endHour = endHour == "12" ? "00" : endHour;

                // Convert PM
                if (startTime.A == "PM") {
                    startHour = parseInt(startHour, 10) + 12;
                }

                if (endTime.A == "PM") {
                    endHour = parseInt(endHour, 10) + 12;
                }

                if (parseInt(String(`${startHour}${startMin}`)) <= parseInt(String(`${endHour}${endMin}`))) {
                    return false;
                }
            }

            return true;
        }
    }
}
</script>

<style scoped>
.btn-kings {
    color: #2c3e50;
}

.invalid-feedback {
    display: block;
}
</style>